<template>
  <footer>
  </footer>
</template>
<script>
import CookieLaw from 'vue-cookie-law'
export default {
  components: { CookieLaw },
}
</script>